<template>
  <div>
    <div v-if="loading" style="display: flex; justify-content: center; align-items: center; min-height: 300px;">
      <a-spin tip="Loading seller details..." />
    </div>
    <div v-else class="container">
      <div class="header">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <router-link
              to="/seller-management"
              style="font-weight: bold; color: #a6a6a6; font-size: 18px"
              >Seller Management</router-link
            >
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <router-link
              to="#"
              style="font-weight: bold; color: #000; font-size: 18px"
            >
              Seller Detail View
            </router-link>
          </a-breadcrumb-item>
        </a-breadcrumb>

        <div class="header-content">
          <a-avatar
            size="large"
            :style="{
              backgroundColor: color,
              verticalAlign: 'middle',
              color: '#047857',
            }"
            :gap="gap"
            :src="null"
            :alt="tradingName"
            class="avatar"
          >
            {{ getInitials(seller.businessDetails.businessName) }}
          </a-avatar>

          <div class="seller-info">
            <h2>{{ this.seller.businessDetails.businessName }}</h2>
            <div style="display: flex; align-items: center; gap: 8px">
              <p>{{ this.seller.businessDetails.businessType }}</p>
              :
              <p>{{ this.seller.accountDetails.operationZone }}</p>
            </div>
            <StatusTag
              :status="this.seller.accountDetails.sellerApprovalStatus"
            />
          </div>
        </div>
      </div>

      <div class="seller-details">
        <a-tabs v-model="activeKey" class="green-tabs" style="min-height: 80vh">
          <a-tab-pane key="1" tab="Overview">
            <Overview :data="seller" />
          </a-tab-pane>
          <a-tab-pane key="2" tab="Business Info" force-render>
            <BusinessInfo :data="seller" @status-changed="refetchSellerData" />
          </a-tab-pane>
          <a-tab-pane key="3" tab="KYC & Compliance">
            <KycCompliance
              :data="seller"
              @status-changed="refetchSellerData"
            />
          </a-tab-pane>
          <a-tab-pane key="4" tab="Product Catalog">
            <ProductCatalog :sellerId="userSetupId" />
          </a-tab-pane>
          <a-tab-pane key="5" tab="Key Accounts">
            <KeyAccountTab :sellerId="userSetupId" />
          </a-tab-pane>
          <a-tab-pane key="6" tab="Stock">
            <SellerStockTab :sellerId="userSetupId" />
          </a-tab-pane>
          <a-tab-pane key="7" tab="Orders & Invoices">
            <OrderAndInvoices :sellerId="userSetupId" />
          </a-tab-pane>
          <a-tab-pane key="8" tab="Wallet"><Wallet :sellerId="userSetupId" /></a-tab-pane>
          <a-tab-pane key="9" tab="Financing">
            <Financing :sellerId="userSetupId" />
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>

</template>

<script>
import Financing from "./Financing.vue";
import OrderAndInvoices from "./orders/OrderAndInvoices.vue";
import Wallet from "./wallet/Wallet.vue";
import { mapGetters } from "vuex";
// import KeyAccountDetailsModal from "./KeyAccountDetailsModal.vue";
import SellerStockTab from "./stock/SellerStockTab.vue";
import Overview from "./overview/Overview.vue";
import BusinessInfo from "./businessInfo/BusinessInfo.vue";
import KycCompliance from "./kyc/KycCompliance.vue";
import ProductCatalog from "./product-catalog/ProductCatalog.vue";
import { mapState, mapActions } from "vuex";
import { getInitials } from "../../utils";
import KeyAccountTab from "./key-accounts/KeyAccountTab.vue";
import StatusTag from "../shared-components/StatusTag.vue";

export default {
  components: {
    OrderAndInvoices,
    Wallet,
    Financing,
    // KeyAccountDetailsModal,
    SellerStockTab,
    Overview,
    BusinessInfo,
    KycCompliance,
    ProductCatalog,
    KeyAccountTab,
    StatusTag,
  },
  name: "SellerDetails",

  props: {
    userSetupId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sellerData: null,
      activeKey: this.$route.query.tab || "1",
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["IsAgentProfileAvailable"]),
    ...mapState("sellerManagement", ["seller"]),
  },

  watch: {
    activeKey(newKey) {
      // Update URL when tab changes
      this.$router
        .replace({
          query: { ...this.$route.query, tab: newKey },
        })
        .catch(() => {});
    },
    sellerData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          console.log("Seller data updated:", newVal);
        }
      },
    },
  },

  created() {
    this.fetchSellerData();
  },

  methods: {
    ...mapActions("sellerManagement", ["fetchSeller"]),
    getInitials,
    refetchSellerData() {
      const { userSetupId } = this.$route.params;
      this.fetchSeller(userSetupId);
    },
    async fetchSellerData() {
      this.loading = true;
      try {
        const userSetupId = this.$route.params.userSetupId;
        const response = await this.fetchSeller(userSetupId);
        if (response?.data?.code !== 200) {
          this.$message.warning("An error occured, please try again");
        }
      } finally {
        this.loading = false;
      }
      console.log("storeseller", this.seller);
    },
  },
};
</script>
<style>
/* Global styles for description labels */
.ant-descriptions-item-label {
  font-weight: 900 !important;
}

.ant-descriptions-item-label span {
  font-weight: 900 !important;
}

/* Component specific styles */
.seller-details .ant-descriptions-item-label {
  font-weight: 900 !important;
}

.seller-details .ant-descriptions-item-label span {
  font-weight: 900 !important;
}
</style>

<style scoped>
.header {
  background-color: #fff;
  padding: 32px 56px;
  border-radius: 8px;
}

.seller-details {
  margin-top: 24px;
  background-color: #fff;
  padding: 16px 56px;
  border-radius: 8px;
}

a-avatar:hover {
  filter: brightness(1.1);
}
.avatar {
  background-color: #d1fae5;
  color: #047857;
  font-size: 14px;
  font-weight: bold;
}
.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
  padding: 24px 0 60px 24px;
}
.company-name {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin-bottom: 0;
}
.meta-info {
  font-size: 16px;
  color: #a6a6a6;
  margin-top: 4px;
  margin-bottom: 0;
}
.extra-info {
  font-size: 16px;
  color: #a6a6a6;
  margin-top: 4px;
  margin-bottom: 0;
}

.seller-info h2 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}
.seller-info p {
  margin: 5px 0;
}
.verified {
  display: inline-block;
  background-color: #e6ffed;
  color: #389e0d;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 4px;
}
.not-verified {
  display: inline-block;
  background-color: #fff1f0;
  color: #cf1322;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 4px;
}
.action-buttons .ant-btn {
  padding: 0 4px;
  height: 24px;
  line-height: 24px;
}
.action-buttons {
  display: flex;
  align-items: center;
  gap: 2px;
}
.note-actions {
  display: flex;
  align-items: center;
}

.note-actions .ant-dropdown-link {
  padding: 4px 8px;
  border-radius: 4px;
}

.note-actions .ant-dropdown-link:hover {
  background-color: #f3f4f6;
}

.ant-menu-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
}

.ant-menu-item:hover {
  background-color: #f3f4f6;
}

/* Update the description label styles */
:deep(.ant-descriptions-item-label) {
  font-weight: 800 !important;
  color: #374151 !important;
}

:deep(.ant-descriptions-item-content) {
  color: #6b7280;
}

/* Additional specificity for nested elements */
:deep(.ant-descriptions-item-label) {
  font-weight: 800 !important;
}

:deep(.ant-descriptions-item-label) > span {
  font-weight: 800 !important;
}

.ant-descriptions-item-label {
  font-weight: bold;
}

.ant-descriptions-title {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
}

/* Add text truncation styles */
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px; /* Adjust this value based on your needs */
}

.long-text {
  word-break: break-word;
  white-space: normal;
  max-height: 100px;
  overflow-y: auto;
}

/* Add styles for descriptions */
.ant-descriptions-item-content {
  max-width: 300px;
  word-break: break-word;
}

.ant-descriptions-item-label {
  font-weight: bold;
  white-space: nowrap;
}

/* Add styles for cards */
.ant-card-body {
  overflow: hidden;
}

/* Add styles for table cells */
.ant-table-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Add hover effect to show full text */
.ant-table-cell:hover {
  white-space: normal;
  overflow: visible;
  position: relative;
  z-index: 1;
  background: white;
}
</style>
